function getIPAndLocation() {
        fetch("https://ipapi.co/json/")
          .then((response) => response.json())
          .then((data) => {
            const lat = data.latitude;
            const lon = data.longitude;
            const map = L.map("map").setView([lat, lon], 10);
            const child = document.getElementById("map");
            child.parentElement.style.paddingTop = "0";
            child.parentElement.style.paddingBottom = "40px";
            
            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
              maxZoom: 19,
            }).addTo(map);

            fetch(
              `https://iwaste.epa.gov/api/facilities?facilityTypeId=36&stateCode=${data.region_code}&epaRegion=`
            )
              .then((response) => response.json())
              .then((facilityData) => {
                facilityData.data.forEach((facility) => {
                  const facilityLat = facility.latitude;
                  const facilityLon = facility.longitude;
                  L.marker([facilityLat, facilityLon])
                    .addTo(map)
                    .bindPopup(
                      `${facility.name}<br>${facility.streetAddress}, ${facility.city}, ${facility.stateCode}`
                    );
                });
              })
              .catch((error) => {
                console.error("Error fetching facilities:", error);
              });
          })
          .catch((error) => {
            console.error("Error fetching IP and location:", error);
          });
      }

      window.onload = getIPAndLocation;